import  allTypes  from "../publicModule/publicMutationTypes"

export default {
  ...allTypes
}
